import React from 'react';
import BaseComponent from 'src/components/BaseComponent';

import { withRouter, lang, permissions, deviceIsMobile } from 'src/helpers';
import mainModel from 'src/model';

import model from './model';
import LANG_CONST from 'src/helpers/lang/const';
import Signup from 'src/components/authPopup/Signup';
import AuthContainer from 'src/components/AuthContainer';

const apiStateId = 'signup';

class BasicStep extends BaseComponent {
  componentDidMount() {
    model.subscribe(this.subscription);
  }

  componentWillUnmount() {
    model.unsubscribe(this.subscription);
  }

  render() {
    const createState = model.getApiState(apiStateId);
    const { invalid } = createState;
    const searchParams = new URLSearchParams(this.props.router.location.search);
    const gid_token = searchParams.has('gid_token') ? searchParams.get('gid_token') : null;
    const code = searchParams.has('code') ? searchParams.get('code') : null;

    return (
      <AuthContainer>
        <div className={'mc-page-auth-box'}>
          <div className={'mc-box-header'}>
            <h4 className='mc-box-title'>{lang.t(LANG_CONST.titles.signup)}</h4>
            <div className='mc-box-title-note'>{lang.t(LANG_CONST.text.signup_connect_dr)}</div>
          </div>
          {createState.error && <p className='mc-error'>{createState.errorMessage}</p>}
          <Signup
            gidToken={gid_token}
            bigForm={!this.props.screenDetail?.isSmallScreen && !deviceIsMobile}
            handleSignupSubmit={(e, data) => {
              mainModel.checkConfirmCookiePolicy().then(
                (accept) =>
                  accept &&
                  model.signUp(
                    data,
                    (valid) => {
                      if (valid) {
                        permissions.history = {
                          url: permissions.PAGES.PHONE_VERIFICATION_PAGE.path,
                          params: { isRedirect: true }
                        };
                      }
                    },
                    gid_token,
                    code
                  )
              );
            }}
            loading={model.getApiState(apiStateId).loading}
            invalid={invalid}
            onClickLogin={(e) => {
              e.preventDefault();
              this.navigate(permissions.PAGES.LOGIN_PAGE.path);
            }}
            router={this.props.router}
          />
        </div>
      </AuthContainer>
    );
  }
}

export default withRouter(BasicStep);
